import React, { useCallback } from 'react'

import PropTypes from 'prop-types'
import {
  Flex,
  FlexItem,
  Text,
  TEXT_VARIANT_LIGHT,
  Link,
  LINK_VARIANT_HIGHLIGHT,
  LINK_VARIANT_DEFAULT,
  Divider,
  IconPaperClip,
  IconClose
} from 'mailup-web-components'
import { useIntl } from 'react-intl'

import styled from '@emotion/styled'

const AttachmentItem = ({
  idMessage,
  name,
  size,
  error,
  onDownloadAttachment,
  onRemoveAttachment,
  isLast
}) => {
  const intl = useIntl()

  const handleDownloadAttachment = useCallback(async () => {
    const { FileName, FileContent } = await onDownloadAttachment(name)

    const link = document.createElement('a')
    link.href = `data:application/octet-stream;base64,${FileContent}`
    link.download = `${idMessage}_${encodeURIComponent(FileName)}`
    document.body.appendChild(link)
    link.click()
    link.parentNode.removeChild(link)
  }, [name])

  const handleRemoveAttachment = useCallback(() => {
    onRemoveAttachment(name)
  }, [name])

  return (
    <>
      <Flex
        alignItems='baseline'
        justifyContent='space-between'
        margin={isLast ? '8px 0 0 0' : '8px 0'}
      >
        <FlexItem>
          <Flex
            alignItems='baseline'
            justifyContent='flex-start'
            columnGap='4px'
          >
            {error ? (
              <Text disabled data-mu-test='download-attachment--error'>
                <PaperClipIcon error />
                {name}
              </Text>
            ) : (
              <Link
                variant={LINK_VARIANT_HIGHLIGHT}
                onClick={handleDownloadAttachment}
                data-mu-test='download-attachment'
              >
                <PaperClipIcon />
                {name}
              </Link>
            )}

            <Text variant={TEXT_VARIANT_LIGHT}>
              ({intl.formatNumber(size)} KB)
            </Text>
          </Flex>
        </FlexItem>
        <Link
          variant={LINK_VARIANT_DEFAULT}
          onClick={handleRemoveAttachment}
          data-mu-test='remove-attachment'
        >
          <CloseIcon />
        </Link>
      </Flex>
      {!isLast && <Divider />}
    </>
  )
}

AttachmentItem.defaultProps = {
  error: false
}

AttachmentItem.propTypes = {
  idMessage: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  error: PropTypes.bool,
  onDownloadAttachment: PropTypes.func.isRequired,
  onRemoveAttachment: PropTypes.func.isRequired,
  isLast: PropTypes.bool.isRequired
}

export default AttachmentItem

const PaperClipIcon = styled(IconPaperClip)`
  margin-right: 8px;
  > svg {
    width: 20px;
    height: 20px;
  }
  ${({ error }) => error && 'color: var(--flush-mahogany);'}
`

const CloseIcon = styled(IconClose)`
  > svg {
    width: 13px;
    height: 13px;
  }
`
